import { render, staticRenderFns } from "./PumpBolusDetailTable.vue?vue&type=template&id=60fcf2d8&scoped=true"
import script from "./PumpBolusDetailTable.vue?vue&type=script&lang=js"
export * from "./PumpBolusDetailTable.vue?vue&type=script&lang=js"
import style0 from "./PumpBolusDetailTable.vue?vue&type=style&index=0&id=60fcf2d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fcf2d8",
  null
  
)

export default component.exports